import React, { useEffect, useRef } from "react";
import {
  CustomLabel,
  adult_select_options_sarvah,
  ageConditionOfType,
  age_constant,
  age_constant_minus,
  child_select_options,
  child_select_options_sarvah,
  female_adult_select_options_sarvah,
  female_child_select_options_sarvah,
  gender_select_options,
  initial_selct_options,
  initial_selct_options_sarvah,
  male_adult_select_options_sarvah,
  male_child_select_options_sarvah,
  pa_female_child_select_options,
  pa_male_child_select_options,
  regex_obj,
  si_select_options_sa,
  typeOFCOVER,
  typeOfCal,
} from "../../Constant";
import CustomSelect from "../../elements/CustomSelect";
import { DatePicker, message } from "antd";
import moment from "moment/moment";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../elements/CustomInput";
import {
  onAmountChange,
  onDatePickerChange,
  onGenderChange,
  onRelationshipChange,
  onSIChange,
} from "../../Redux/CIReducer";

const AgePredict = (date) => {
  if (date == "") return "00";
  //
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  //

  date.split("/").reverse().join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  // if (newDate === 0){
  //   return `${moment().diff(new Date(new_date), "days")} days`
  // }
  // if (`${newDate}` == "NaN"){
  //   return "00"
  // }
  return newDate;
};

const SarvahDropDownCardContent = ({
  lable = "Adult",
  num = 0,
  p_data,
  onDataChange,
  user_data_info,
}) => {
  const [data, setData] = React.useState(p_data);
  const typeOfCalculator = useSelector((s) => s.common.type);
  const { adultMember, childMember, coverType } = useSelector((s) => s.CI);


  const dispatch = useDispatch();
  useEffect(() => {
    // dataHandle()
  }, [data]);

  const dateAllowedForChild = (e) => {
    return (
      e &&
      (e.valueOf() < Date.now() - age_constant_minus["31"] ||
        e.valueOf() > Date.now() - age_constant_minus["91"])
    );
  };

  const datePermissible = () => {
    if (lable === "Adult") {
      return moment(Date.now() - age_constant_minus["30"]).format("DD/MM/YYYY");
    } else {
      return moment(Date.now() - age_constant_minus["18"]).format("DD/MM/YYYY");
    }
  };

  const relationshipData = () => {
    // if (num === 1 && lable === "Adult") {
    //   return initial_selct_options_sarvah;
    // } else if (lable === "Adult" && p_data.gender === "MALE" && num !== 2) {
    //   const newArr = [...male_adult_select_options_sarvah]
    //   newArr.splice(1,1)
    //   return newArr;
    // } else if (lable === "Adult" && p_data.gender === "FEMALE"  && num !== 2) {
    //   const newArr = [...female_adult_select_options_sarvah]
    //   newArr.splice(1,1)
    //   return newArr;
    // }
    
    
    if (lable === "Adult" && p_data.gender === "MALE") {
      return male_adult_select_options_sarvah
      //return relationshipfromAdultArr.length > 0 ? male_adult_select_options_sarvah.filter(item => !relationshipfromAdultArr.includes(item.value))  : male_adult_select_options_sarvah
    } else if (lable === "Adult" && p_data.gender === "FEMALE") {
      return female_adult_select_options_sarvah;
    } else if (lable !== "Adult" && p_data.gender === "MALE") {
      return male_child_select_options_sarvah;
    } else if (lable !== "Adult" && p_data.gender === "FEMALE") {
      return female_child_select_options_sarvah;
    }else if (p_data.gender === "OTHER") {
    return lable === "Adult" ? adult_select_options_sarvah : child_select_options_sarvah;
    }
    return initial_selct_options
  }

  const formatSi = (si) => {
    let dig = si / 100000;
    if (
      p_data.relationship === "SPOUSE" ||
      p_data.relationship === "SELF"
    ) {
      return dig * 0.6 < 1 ? dig * 0.6 : dig * 0.6 > 50 ? 50 : dig * 0.6;
    } else {
      return dig * 0.3 < 1 ? dig * 0.3 : dig * 0.3 > 30 ? 30 : dig * 0.3;
    }
  };

  const siSelectOptions = () => {
    let UPPER_LIMIT = (p_data.annualI / 100000) * 10;
    if (coverType === typeOFCOVER.ml) {
      if (p_data.relationship == "SPOUSE" || p_data.relationship == "SELF") {
        UPPER_LIMIT = (p_data.annualI / 100000) * 10;
      } else {
        UPPER_LIMIT = (p_data.annualI / 100000) * 10 > 30 ? 30 : (p_data.annualI / 100000) * 10
      }
    }
    if (UPPER_LIMIT > 100) {
      UPPER_LIMIT = 100;
    }

    if (num === 1 && lable === "Adult") {
      return si_select_options_sa({
        uppercap: UPPER_LIMIT,
        type: typeOfCal.mchiSarvah,
      });
    } else if (coverType === typeOFCOVER.ml) {
      if (p_data.annualI < 25000) {
        return si_select_options_sa({
          uppercap: formatSi(user_data_info.adultData[0]?.si),
          type: typeOfCal.mchiSarvah,
        }).splice(0, 1);
      } else {
        return si_select_options_sa({
          uppercap: UPPER_LIMIT,
          type: typeOfCal.mchiSarvah,
        });
      }
    } else if (coverType === typeOFCOVER.ff) {
      const twoEarningMember = adultMember.filter(
        (ei) => ei.annualI >= 25000
      );
      if (lable === "Adult" && p_data.annualI >= 25000) {
        return si_select_options_sa({
          uppercap: UPPER_LIMIT,
          type: typeOfCal.mchiSarvah,
        });
      } else if (twoEarningMember.length === 2) {
        let earningMember = adultMember.filter(
          (ei) => ei.annualI >= 25000
        );
        let BIG_SI =
          parseFloat(earningMember[0]?.si) >
            parseFloat(earningMember[1]?.si)
            ? earningMember[0]?.si
            : earningMember[1]?.si;
        return si_select_options_sa({
          uppercap: formatSi(BIG_SI),
          type: typeOfCal.mchiSarvah,
        });
      } else {
        return si_select_options_sa({
          uppercap: formatSi(user_data_info.adultData[0]?.si),
          type: typeOfCal.mchiSarvah,
        });
      }
    } else {
      return si_select_options_sa({
        uppercap: formatSi(user_data_info.adultData[0]?.si),
        type: typeOfCal.mchiSarvah,
      }).splice(0, 1);
    }
  };


  const dataHandle = (type, e, pos) => {
    switch (type) {
      case "dob":
        dispatch(onDatePickerChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "gender":
        dispatch(onGenderChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "relationship":
        dispatch(onRelationshipChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "amt":
        dispatch(onAmountChange({ type: lable, value: e, pos: num - 1 }));
        break;
      case "si":
        dispatch(onSIChange({ type: lable, value: e, pos: num - 1 }));
        break;
    }
  };

  const warning = () => {
    if (lable === "Adult" && AgePredict(data.dob) > 0) {
      return ageConditionOfType(
        typeOfCalculator,
        AgePredict(data.dob),
        user_data_info.adult
      );
      // return parseInt(AgePredict(data.dob)) > 65;
    }
  };

  /* const disablePastDate  = (current) =>{
    if(lable == 'Adult'){
    return current && current > moment().subtract(18,'years')
    }
    if(lable == 'Child'){
      return current && current > moment().subtract(17,'years')
      }
  } */
  return (
    <div className="dob-detail-box">
      <CustomLabel font_size="12" color="#b2b2b2">
        {lable} 0{`${num}`} Age {AgePredict(data?.dob)}
      </CustomLabel>
      <div className="row gy-2">
        <div className="col-6">
          {data.dob == "" ? (
            <DatePicker
              allowClear={true}
              style={{ width: "100%" }}
              defaultPickerValue={dayjs(datePermissible(), "DD/MM/YYYY")}
              placement={"bottom"}
              onChange={(_, e) => {
                setData({ ...data, dob: e });
                setTimeout(() => {
                  dataHandle("dob", e, num);
                }, 200);
              }}
              disabledDate={(e) => {
                if (lable === "Adult") {
                  return (
                    e && e.valueOf() > Date.now() - age_constant_minus["18"]
                  );
                } else {
                  return dateAllowedForChild(e);
                }
              }}
             // disabledDate={disablePastDate}
              showToday={false}
              format="DD/MM/YYYY"
            />
          ) : (
            <DatePicker
              status={warning() && "error"}
              allowClear={true}
              style={{ width: "100%" }}
              value={dayjs(data.dob, "DD/MM/YYYY")}
              placement={"bottom"}
              onChange={(_, e) => {
                setData({ ...data, dob: e });
                setTimeout(() => {
                  dataHandle("dob", e);
                }, 200);
              }}
            //  disabledDate={disablePastDate}
              disabledDate={(e) => {
                if (lable === "Adult") {
                  return (
                    e && e.valueOf() > Date.now() - age_constant_minus["18"]
                  );
                } else {
                  return dateAllowedForChild(e);
                }
              }}
              showToday={false}
              format="DD/MM/YYYY"
            />
          )}
        </div>
        <div className="col-6">
          <CustomSelect
            defaultValue={p_data.gender}
            options={gender_select_options}
            onChange={(e) => {
              setData({ ...data, gender: e.target.value });
              setTimeout(() => {
                dataHandle("gender", e.target.value);
              }, 200);
            }}
          />
        </div>
        <div className="col-6">
          <CustomSelect
            defaultValue={p_data.relationship}
            disabled={
              lable === "Adult"
                ? adultMember[num - 1]?.gender === ""
                : childMember[num - 1]?.gender === ""
            }
            options={relationshipData()}
            onChange={(e) => {
              setTimeout(() => {
                dataHandle("relationship", e.target.value);
              }, 200);
            }}
          />
        </div>
        {/*   <div className="col-6">
          <CustomInput
            label={""}
            disabled={
              lable === "Adult"
                ? false
                // adultMember[num - 1]?.relationship === "" ||
                // (coverType === typeOFCOVER.ff &&
                //   adultMember[num - 1]?.relationship !== "SPOUSE" &&
                //   adultMember[num - 1]?.relationship !== "SELF")
                : true
            }
            regex={regex_obj.income_number}
            placeholder="Annual Income"
            value={
              lable === "Adult"
                ? adultMember[num - 1]?.annualI
                : childMember[num - 1]?.annualI
            }
            onChange={(e) => {
              dataHandle("amt", e.target.value);
            }}
            showError={false}
            maxLength={8}
            readOnly={false}
            height='30px'
          />
        </div> */}
        {/* <div className="col-6">
          <CustomSelect
            defaultValue={p_data.si}
            options={siSelectOptions()}
            onChange={(e) => {
              dataHandle("si", e.target.value);
            }}
          />
        </div> */}
      </div>
    </div>
  );
};

export default React.memo(SarvahDropDownCardContent);